import { ICON_TYPES } from '../constants';

export const WhatsAppLogoIcon = (): JSX.Element => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M16 32C7.16071 32 0 24.8333 0 16C0 7.16071 7.16071 0 16 0C24.8333 0 32 7.16071 32 16C32 24.8333 24.8333 32 16 32Z"
          fill="url(#paint0_linear_2865_90969)"
        />
        <path
          d="M15.9996 6.7738C10.9103 6.7738 6.77344 10.9107 6.77344 16C6.77344 17.8452 7.30915 19.6071 8.32701 21.119L6.94606 25.2262L11.1961 23.869C12.6365 24.7559 14.2913 25.2202 15.9996 25.2202C21.083 25.2202 25.2199 21.0833 25.2199 15.994C25.2199 10.9048 21.0889 6.7738 15.9996 6.7738ZM15.9996 23.881C14.4461 23.881 12.9461 23.4286 11.6603 22.5774L11.3925 22.3988L9.0532 23.1488L9.80915 20.8929L9.60677 20.6131C8.62463 19.2619 8.10677 17.6667 8.10677 15.994C8.10677 11.6429 11.6425 8.10714 15.9937 8.10714H15.9996C20.3449 8.10714 23.8865 11.6429 23.8865 15.994C23.8865 20.3452 20.3508 23.881 15.9996 23.881Z"
          fill="white"
        />
        <path
          d="M20.6481 18.0417C20.3981 17.9167 19.1719 17.3095 18.9457 17.2321C18.7195 17.1488 18.5052 17.1786 18.3326 17.4167C18.0945 17.756 17.8564 18.0952 17.6659 18.3036C17.5171 18.4643 17.2671 18.4821 17.0647 18.3988C16.785 18.2857 16.0112 18.0119 15.0588 17.1607C14.3207 16.5 13.8147 15.6845 13.6719 15.4345C13.529 15.1845 13.654 15.0357 13.7731 14.9048C13.8981 14.75 14.0171 14.6369 14.1481 14.4941C14.2731 14.3512 14.3445 14.2738 14.4278 14.1012C14.5112 13.9345 14.4516 13.7619 14.3921 13.6369C14.3326 13.5119 13.8266 12.2857 13.6243 11.7857C13.4576 11.3869 13.3326 11.375 13.0826 11.3631C12.9993 11.3571 12.904 11.3512 12.7969 11.3512C12.4695 11.3512 12.1302 11.4464 11.9219 11.6607C11.6719 11.9167 11.0469 12.5179 11.0469 13.7441C11.0469 14.9702 11.9397 16.1607 12.0647 16.3274C12.1897 16.4941 13.8088 19.0476 16.3266 20.0893C18.2909 20.9048 18.8743 20.8274 19.3207 20.7321C19.9754 20.5893 20.7909 20.1071 20.9993 19.5238C21.2076 18.9405 21.2076 18.4405 21.1481 18.3393C21.0647 18.2262 20.8981 18.1667 20.6481 18.0417Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2865_90969"
          x1="4.97124"
          y1="7.16139"
          x2="26.8138"
          y2="24.666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8BE93C" />
          <stop offset="1" stopColor="#09A131" />
        </linearGradient>
        <clipPath id="clip0_2865_90969">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

WhatsAppLogoIcon.iconType = ICON_TYPES.WHATSAPP_LOGO;
